import React, { useState } from "react";
import Collapsible from "react-collapsible";
import { formatDate } from "../../../../../Helper_functions";

const ESSMobileTableItem = (props) => {
  const [IsOpen, setIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const replaceUnavailableProperty = (Property) => {
    if (Property === null || Property === undefined) {
      return <p className="unavailable-property">({translateText("not_available")})</p>;
    } else {
      return Property;
    }
  };

  const shortenTitle = (Title) => {
    if (Title.length < 40) {
      return Title;
    } else {
      let Short = Title.slice(0, 36) + " ...";
      return (
        <>
          <span className="popup-text">{Title}</span>
          {Short}
        </>
      );
    }
  };

  const selectJPACode = () => {
    if (props.SelectedJPAType === "Vacancies") {
      return props.RowItem.globalPositionCode;
    } else if (props.SelectedJPAType === "Projects") {
      return props.RowItem.globalProjectCode;
    } else if (props.SelectedJPAType === "Activities") {
      return props.RowItem.globalActivityCode;
    }
  };

  const formatTheDate = (date) => {
    if (date) return formatDate(new Date(date), "dd-MM-y");
    return date;
  };

  return (
    <div className="mobile-row-item is-mobile">
      <section className="row-main-info">
        <p>{shortenTitle(props.RowItem.title)}</p>
        <p>{"(" + selectJPACode() + ")"}</p>
      </section>
      <Collapsible
        onOpening={() => setIsOpen(true)}
        onClosing={() => setIsOpen(false)}
        trigger={
          <span
            className={
              IsOpen ? "circle-indidcator rotated" : "circle-indidcator"
            }
          >
            <i className="feather-chevron-down"></i>
          </span>
        }
      >
        <section className="mobile-row-item-content">
          <span>
            <p>{translateText("location")}</p>
            <p>{replaceUnavailableProperty(props.RowItem.workCity)}</p>
          </span>
          <span>
            <p>{translateText("hiring_manager")}</p>
            <p>{replaceUnavailableProperty(props.RowItem.hiringManager)}</p>
          </span>
          <>
            <span>
              <p>{translateText("match")}</p>
              <p>{parseInt(props.RowItem.similarity * 100)}</p>
            </span>
            <span>
              <p>{translateText("date")}</p>
              <p>{formatTheDate(props.RowItem.applicationDate)}</p>
            </span>
            <span>
              <p>{translateText("status")}</p>
              <p>{replaceUnavailableProperty(props.RowItem.status)}</p>
            </span>
          </>
          <span>
            <p>{translateText("others_applied")}</p>
            <p>{replaceUnavailableProperty(props.RowItem.othersApplied)}</p>
          </span>
        </section>
      </Collapsible>
    </div>
  );
};

export default ESSMobileTableItem;
